interface Props {
  type: string
}

export default function Icon ({ type }: Props): JSX.Element {
  switch (type) {
    case 'contact_data':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            d="M12.635 4.26122C12.5049 4.12575 12.3473 4.02202 12.1737 3.95766L12.1768 3.30152C12.1791 2.95702 12.0484 2.62587 11.8138 2.38151C11.5791 2.13715 11.2599 1.99977 10.9271 2H4.92352C4.59229 2.00056 4.27468 2.13692 4.04053 2.37938C3.80627 2.62183 3.67452 2.95054 3.67396 3.29334V5.78661H3.34132C3.15322 5.78661 3.00066 5.94451 3.00066 6.13918C3.00066 6.33397 3.15322 6.49175 3.34132 6.49175H3.67396V7.19757H3.34132C3.15311 7.19757 3.00044 7.35547 3.00044 7.55037C3.00044 7.74516 3.15311 7.90317 3.34132 7.90317H3.67396V8.60776H3.34132C3.153 8.60776 3.00032 8.76576 3.00032 8.96067C3.00032 9.15557 3.153 9.31358 3.34132 9.31358H3.67396V10.0194L3.34132 10.0193C3.25084 10.0192 3.16405 10.0562 3.10001 10.1224C3.03597 10.1885 3 10.2783 3 10.372C3 10.4656 3.03597 10.5553 3.10001 10.6215C3.16405 10.6877 3.25084 10.7247 3.34132 10.7246H3.67396V11.4301H3.34132C3.15322 11.4301 3.00066 11.5879 3.00066 11.7827C3.00066 11.9775 3.15322 12.1353 3.34132 12.1353H3.67396V12.7472C3.6744 13.09 3.80627 13.4186 4.04053 13.661C4.27469 13.9034 4.59229 14.0397 4.92352 14.04H11.7404C12.0716 14.0398 12.3892 13.9035 12.6233 13.6611C12.8576 13.4187 12.9893 13.09 12.9895 12.7472L13 5.17625C13.0015 4.83299 12.8701 4.5033 12.6349 4.26117L12.635 4.26122ZM4.92354 2.70568H10.9271C11.0783 2.70602 11.2233 2.76848 11.3299 2.87939C11.4367 2.9903 11.4964 3.14057 11.4959 3.29713L11.4922 3.88206H4.92367C4.72083 3.88172 4.53349 3.76958 4.43216 3.58768C4.33085 3.4059 4.33085 3.18195 4.43216 3.00005C4.53347 2.81816 4.72081 2.70602 4.92367 2.70568L4.92354 2.70568ZM12.3088 12.7473C12.3085 12.9032 12.2485 13.0526 12.142 13.1628C12.0355 13.2729 11.891 13.3348 11.7404 13.3349H4.92358C4.77307 13.3347 4.62874 13.2727 4.52233 13.1626C4.41593 13.0525 4.35601 12.9031 4.35579 12.7473V12.1354H4.70469C4.89291 12.1354 5.04535 11.9776 5.04535 11.7828C5.04535 11.588 4.8929 11.4302 4.70469 11.4302H4.35579V10.7246H4.70469C4.79517 10.7247 4.88196 10.6877 4.946 10.6216C5.01004 10.5554 5.04601 10.4657 5.04601 10.3721C5.04601 10.2784 5.01004 10.1886 4.946 10.1224C4.88196 10.0563 4.79517 10.0193 4.70469 10.0194H4.35579V9.31366H4.70469C4.89301 9.31366 5.04569 9.15566 5.04569 8.96075C5.04569 8.76585 4.89301 8.60784 4.70469 8.60784H4.35579V7.90325H4.70469C4.89301 7.90325 5.04558 7.74524 5.04558 7.55045C5.04558 7.35555 4.89301 7.19765 4.70469 7.19765H4.35579V6.49183H4.70469C4.89291 6.49183 5.04535 6.33404 5.04535 6.13926C5.04535 5.94458 4.8929 5.78669 4.70469 5.78669H4.35579V4.44481C4.53133 4.53878 4.72594 4.5879 4.92358 4.58779H11.7504C11.9011 4.58756 12.0459 4.64946 12.1525 4.75981C12.2592 4.87016 12.3192 5.01976 12.3192 5.17586L12.3088 12.7473ZM9.86262 8.76717C9.81982 8.40473 9.61308 8.08501 9.30579 7.90592C9.44427 7.67042 9.49726 7.39164 9.45543 7.11937C9.4135 6.8472 9.27946 6.59926 9.07727 6.41983C8.87497 6.24052 8.61763 6.14138 8.35128 6.14026C8.08494 6.13914 7.82696 6.23614 7.62325 6.41377C7.41965 6.59152 7.28367 6.83834 7.23967 7.11018C7.19568 7.38202 7.24661 7.66124 7.38324 7.89788C7.06794 8.07485 6.8549 8.3987 6.81146 8.7672L6.5032 11.3876C6.4916 11.4878 6.52194 11.5884 6.58663 11.6639C6.65132 11.7395 6.74407 11.7829 6.84159 11.7831H9.83351C9.93092 11.7826 10.0236 11.7392 10.0881 11.6636C10.1527 11.5881 10.1832 11.4878 10.1719 11.3876L9.86262 8.76717ZM8.34705 6.84472C8.46408 6.84483 8.57622 6.89294 8.659 6.97861C8.74168 7.06429 8.78805 7.18047 8.78805 7.30158C8.78805 7.4227 8.74157 7.53876 8.65879 7.62444C8.57611 7.71 8.46386 7.75811 8.34683 7.75811C8.22992 7.75822 8.11766 7.71011 8.03488 7.62455C7.9521 7.53899 7.90561 7.42281 7.9055 7.3017C7.9055 7.18058 7.9521 7.06429 8.03488 6.97861C8.11767 6.89293 8.22992 6.84482 8.34705 6.84471L8.34705 6.84472ZM7.22634 11.0772L7.48856 8.85218C7.50124 8.74497 7.5513 8.6464 7.62932 8.57474C7.70733 8.50319 7.80799 8.46372 7.91234 8.46361H8.76217C8.86641 8.46394 8.96707 8.50342 9.04519 8.57496C9.12332 8.64651 9.17349 8.74508 9.18649 8.85218L9.44817 11.0772L7.22634 11.0772Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </svg>
      )
    case 'credit_assessment':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.86216 2.00044C5.66987 2.01856 5.52366 2.17089 5.5242 2.35267V2.63389H3.37684C3.27681 2.63349 3.18067 2.67071 3.10997 2.73718C3.03918 2.80374 2.99959 2.89404 3 2.98817V13.6457C2.99958 13.7397 3.03917 13.83 3.10997 13.8966C3.18067 13.9631 3.27682 14.0003 3.37684 14H12.6232C12.7232 14.0003 12.8193 13.9631 12.89 13.8966C12.9608 13.83 13.0004 13.7397 13 13.6457V2.98817C13.0004 2.89404 12.9608 2.80374 12.89 2.73718C12.8193 2.67071 12.7232 2.63349 12.6232 2.63389H10.4758V2.35267C10.4754 2.15849 10.3083 2.00115 10.1019 2.00044H5.89809C5.88615 1.99985 5.8741 1.99985 5.86216 2.00044H5.86216ZM6.27493 2.70694H9.72507V3.26937H6.27493V2.70694ZM3.75073 3.3397H5.5242V3.62092C5.52336 3.81578 5.69083 3.9744 5.89809 3.97521H10.1019C10.3092 3.97442 10.4767 3.81579 10.4758 3.62092V3.3397H12.2493V13.2942H3.75073V3.3397ZM6.89576 4.99395C6.79783 4.9974 6.70524 5.03669 6.63769 5.10355L5.5849 6.10091L5.24986 5.67909C5.19393 5.59628 5.10386 5.53917 5.00132 5.52134C4.89879 5.50352 4.79291 5.52656 4.70921 5.58505C4.62553 5.64354 4.57138 5.73206 4.55996 5.82955C4.54844 5.92703 4.5806 6.02451 4.64867 6.09886L5.24105 6.85154C5.30651 6.93396 5.40706 6.98545 5.5162 6.99244C5.62543 6.99944 5.73247 6.96133 5.80925 6.88807L7.16995 5.59845C7.28013 5.49663 7.3127 5.34183 7.25206 5.20823C7.19153 5.07471 7.05014 4.98963 6.89576 4.99397L6.89576 4.99395ZM8.2198 5.6398C8.01233 5.6398 7.84412 5.79793 7.84412 5.99301C7.84412 6.18807 8.01232 6.34632 8.2198 6.34632H11.1576C11.3651 6.34632 11.5334 6.18808 11.5334 5.99301C11.5334 5.79794 11.3651 5.6398 11.1576 5.6398H8.2198ZM6.89576 7.63317C6.79825 7.63583 6.70566 7.67413 6.63769 7.74L5.5849 8.73737L5.24986 8.31555C5.19215 8.23608 5.1025 8.18222 5.00164 8.16647C4.90068 8.15061 4.7973 8.17424 4.71529 8.23175C4.63339 8.28925 4.57987 8.37571 4.5673 8.47112C4.55473 8.56664 4.58416 8.66274 4.64868 8.73737L5.24106 9.48797C5.3062 9.57068 5.40654 9.62248 5.51567 9.62996C5.6249 9.63735 5.73215 9.59964 5.80923 9.52657L7.16993 8.23763C7.28011 8.13581 7.31268 7.98102 7.25204 7.84741C7.19151 7.71389 7.05012 7.62882 6.89574 7.63315L6.89576 7.63317ZM8.18095 8.27901C7.97704 8.29309 7.82256 8.45783 7.83312 8.64974C7.8437 8.84165 8.01547 8.99055 8.2198 8.98483H11.1576C11.3617 8.98059 11.5248 8.82383 11.5248 8.63192C11.5248 8.44001 11.3617 8.28325 11.1576 8.27901H8.2198C8.20682 8.27832 8.19393 8.27832 8.18095 8.27901H8.18095ZM6.89576 10.2696C6.79793 10.2729 6.70535 10.312 6.63769 10.3785L5.5849 11.3766L5.24986 10.9548C5.19435 10.8712 5.10428 10.8132 5.00132 10.7948C4.89837 10.7765 4.79196 10.7994 4.70776 10.8581C4.62366 10.9168 4.5693 11.0058 4.5581 11.1038C4.54689 11.2017 4.57978 11.2996 4.64869 11.3739L5.24107 12.1265C5.30653 12.209 5.40708 12.2604 5.51622 12.2674C5.62545 12.2744 5.73249 12.2363 5.80927 12.1631L7.16997 10.8734C7.27952 10.7715 7.31178 10.617 7.25135 10.4838C7.19081 10.3506 7.04984 10.2656 6.89577 10.2696L6.89576 10.2696ZM8.2198 10.9155C8.01578 10.9197 7.85272 11.0765 7.85272 11.2684C7.85272 11.4602 8.01579 11.617 8.2198 11.6213H11.1576C11.3616 11.617 11.5247 11.4602 11.5247 11.2684C11.5247 11.0765 11.3616 10.9197 11.1576 10.9155H8.2198Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'financial_data':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.26839 3.35056C6.26839 4.09648 5.66374 4.70113 4.91782 4.70113C4.17191 4.70113 3.56726 4.09648 3.56726 3.35056C3.56726 2.60465 4.17191 2 4.91782 2C5.66374 2 6.26839 2.60465 6.26839 3.35056Z"
            fill="currentColor"
          />

          <path
            d="M5.57759 5.08578L4.91915 6.39452L4.26072 5.08578H3.56319C3.05182 5.08578 2.62548 5.43791 2.51349 5.91419C2.5081 5.93848 2.5 5.96142 2.5 5.9857V9.48682C2.5 9.82142 2.76986 10.0913 3.10309 10.0913C3.2704 10.0913 3.42017 10.0238 3.52944 9.91453C3.63873 9.80524 3.6873 9.65412 3.6873 9.48682V7.02316V13.3955C3.6873 13.5628 3.7723 13.714 3.88294 13.8232C3.99222 13.9325 4.14467 14 4.312 14C4.6385 14 4.90564 13.7409 4.91645 13.4171V10.0981V13.4171C4.92454 13.5723 4.992 13.7207 5.09589 13.8232C5.20518 13.9325 5.35899 14 5.52495 14C5.85955 14 6.12805 13.7288 6.12805 13.3955L6.12939 7.02316V9.48683C6.12939 9.82142 6.39518 10.0913 6.72844 10.0913C6.89574 10.0913 7.0428 10.0238 7.1521 9.91453C7.26139 9.80524 7.32885 9.65412 7.32885 9.48682V6.16235C7.32885 5.56599 6.84719 5.08566 6.25083 5.08566L5.57759 5.08578Z"
            fill="currentColor"
          />

          <path
            d="M7.62977 13.8138C7.88747 13.4886 8.14518 13.1635 8.40288 12.8383C8.8144 12.3202 9.22456 11.8021 9.63605 11.284C9.7305 11.1653 9.82494 11.0465 9.91805 10.9278C9.78447 10.9453 9.65091 10.9629 9.51733 10.9791C9.9464 11.2489 10.3754 11.5174 10.8045 11.7873C10.8652 11.825 10.9259 11.8642 10.9866 11.9019C11.1108 11.9802 11.2862 11.9519 11.3873 11.8507C11.6693 11.57 11.9513 11.2894 12.2333 11.0088C12.6786 10.5649 13.1238 10.1223 13.5704 9.67842C13.6729 9.57588 13.7755 9.47334 13.8793 9.37215C14.0021 9.24937 14.0102 9.02539 13.8793 8.90532C13.7471 8.78389 13.5434 8.77444 13.4125 8.90532C13.1305 9.18595 12.8485 9.46659 12.5665 9.74723C12.1213 10.1911 11.6761 10.6337 11.2295 11.0776C11.1269 11.1801 11.0244 11.2826 10.9205 11.3838C11.0541 11.3663 11.1877 11.3488 11.3212 11.3326C10.8922 11.0627 10.4631 10.7942 10.0341 10.5244C9.97336 10.4866 9.91264 10.4475 9.85193 10.4097C9.73994 10.3395 9.5389 10.3503 9.45122 10.461C9.19352 10.7861 8.9358 11.1113 8.67811 11.4364C8.26659 11.9545 7.85643 12.4726 7.44493 12.9907C7.35049 13.1095 7.25604 13.2282 7.16294 13.347C7.10627 13.4185 7.0658 13.4859 7.0658 13.5804C7.0658 13.6613 7.10223 13.7585 7.16294 13.8138C7.28167 13.9231 7.51507 13.9581 7.62977 13.8138V13.8138Z"
            fill="currentColor"
          />

          <path
            d="M12.2845 9.46668H13.4786H13.6486C13.5379 9.35605 13.4286 9.24676 13.318 9.13614V10.3302V10.5002C13.318 10.6729 13.4705 10.8388 13.6486 10.8307C13.828 10.8226 13.9791 10.685 13.9791 10.5002V9.30614V9.13614C13.9791 8.95804 13.828 8.80559 13.6486 8.80559H12.4545H12.2845C12.1118 8.80559 11.9458 8.95805 11.954 9.13614C11.9621 9.31558 12.0997 9.46668 12.2845 9.46668Z"
            fill="currentColor"
          />

          <path
            d="M12.9038 5.54442V5.54847C12.9038 6.65483 12.0079 7.55206 10.9015 7.55206C9.79516 7.55206 8.90198 6.65483 8.90198 5.54847C8.90198 4.4421 9.80056 3.54488 10.9069 3.54488V5.54442L12.9038 5.54442Z"
            fill="currentColor"
          />

          <path
            d="M13.3787 5.04508H11.3926V3.07521H11.398C11.5694 3.07521 11.7353 3.09275 11.8932 3.13323C11.9094 3.13728 11.9242 3.14267 11.9404 3.14267C12.7715 3.38553 13.3787 4.1411 13.3787 5.04506L13.3787 5.04508Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'financial_data_from_balance_sheet':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_503_371)">
            <g clipPath="url(#clip1_503_371)">
              <path
                d="M11.9 11.75H8.6V5.99316C8.98288 5.81855 9.27688 5.48105 9.41338 5.06602L11.8884 4.20156C12.0455 4.14668 12.1301 3.96953 12.0774 3.80586L11.8867 3.21328C11.834 3.04961 11.6639 2.96152 11.5068 3.01641L9.29581 3.78848C9.03687 3.31953 8.55669 3 8 3C7.17163 3 6.5 3.69961 6.5 4.5625C6.5 4.62949 6.51106 4.69355 6.51894 4.7584L4.11163 5.59922C3.9545 5.6541 3.86994 5.83125 3.92263 5.99492L4.11331 6.5875C4.166 6.75117 4.33606 6.83926 4.49319 6.78437L7.15662 5.8541C7.23294 5.9082 7.31469 5.9541 7.40019 5.99316V12.6875C7.40019 12.8602 7.53444 13 7.70019 13H11.9002C12.0659 13 12.2002 12.8602 12.2002 12.6875V12.0625C12.2 11.8898 12.0658 11.75 11.9 11.75ZM13.9996 8.9375C13.9996 8.62148 14.0248 8.76699 12.4049 5.39238C12.074 4.70312 11.1264 4.70176 10.7949 5.39238C9.16138 8.7959 9.20038 8.63145 9.20038 8.9375H9.2C9.2 9.80039 10.2746 10.5 11.6 10.5C12.9254 10.5 14 9.80039 14 8.9375H13.9996ZM10.25 8.625L11.6 5.8125L12.95 8.625H10.25ZM5.20494 7.89238C4.874 7.20312 3.92638 7.20176 3.59487 7.89238C1.96137 11.2959 2.00038 11.1314 2.00038 11.4375H2C2 12.3004 3.07456 13 4.4 13C5.72544 13 6.8 12.3004 6.8 11.4375H6.79962C6.79962 11.1215 6.82475 11.267 5.20494 7.89238ZM3.05 11.125L4.4 8.3125L5.75 11.125H3.05Z"
                fill="currentColor"
              />
            </g>
          </g>

          <defs>
            <clipPath id="clip0_503_371">
              <rect
                fill="white"
                height="26"
                width="26"
              />
            </clipPath>

            <clipPath id="clip1_503_371">
              <rect
                fill="white"
                height="10"
                transform="translate(2 3)"
                width="12"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'financial_data_from_income_statement':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.26839 3.35056C6.26839 4.09648 5.66374 4.70113 4.91782 4.70113C4.17191 4.70113 3.56726 4.09648 3.56726 3.35056C3.56726 2.60465 4.17191 2 4.91782 2C5.66374 2 6.26839 2.60465 6.26839 3.35056Z"
            fill="currentColor"
          />

          <path
            d="M5.57759 5.08578L4.91915 6.39452L4.26072 5.08578H3.56319C3.05182 5.08578 2.62548 5.43791 2.51349 5.91419C2.5081 5.93848 2.5 5.96142 2.5 5.9857V9.48682C2.5 9.82142 2.76986 10.0913 3.10309 10.0913C3.2704 10.0913 3.42017 10.0238 3.52944 9.91453C3.63873 9.80524 3.6873 9.65412 3.6873 9.48682V7.02316V13.3955C3.6873 13.5628 3.7723 13.714 3.88294 13.8232C3.99222 13.9325 4.14467 14 4.312 14C4.6385 14 4.90564 13.7409 4.91645 13.4171V10.0981V13.4171C4.92454 13.5723 4.992 13.7207 5.09589 13.8232C5.20518 13.9325 5.35899 14 5.52495 14C5.85955 14 6.12805 13.7288 6.12805 13.3955L6.12939 7.02316V9.48683C6.12939 9.82142 6.39518 10.0913 6.72844 10.0913C6.89574 10.0913 7.0428 10.0238 7.1521 9.91453C7.26139 9.80524 7.32885 9.65412 7.32885 9.48682V6.16235C7.32885 5.56599 6.84719 5.08566 6.25083 5.08566L5.57759 5.08578Z"
            fill="currentColor"
          />

          <path
            d="M7.62977 13.8138C7.88747 13.4886 8.14518 13.1635 8.40288 12.8383C8.8144 12.3202 9.22456 11.8021 9.63605 11.284C9.7305 11.1653 9.82494 11.0465 9.91805 10.9278C9.78447 10.9453 9.65091 10.9629 9.51733 10.9791C9.9464 11.2489 10.3754 11.5174 10.8045 11.7873C10.8652 11.825 10.9259 11.8642 10.9866 11.9019C11.1108 11.9802 11.2862 11.9519 11.3873 11.8507C11.6693 11.57 11.9513 11.2894 12.2333 11.0088C12.6786 10.5649 13.1238 10.1223 13.5704 9.67842C13.6729 9.57588 13.7755 9.47334 13.8793 9.37215C14.0021 9.24937 14.0102 9.02539 13.8793 8.90532C13.7471 8.78389 13.5434 8.77444 13.4125 8.90532C13.1305 9.18595 12.8485 9.46659 12.5665 9.74723C12.1213 10.1911 11.6761 10.6337 11.2295 11.0776C11.1269 11.1801 11.0244 11.2826 10.9205 11.3838C11.0541 11.3663 11.1877 11.3488 11.3212 11.3326C10.8922 11.0627 10.4631 10.7942 10.0341 10.5244C9.97336 10.4866 9.91264 10.4475 9.85193 10.4097C9.73994 10.3395 9.5389 10.3503 9.45122 10.461C9.19352 10.7861 8.9358 11.1113 8.67811 11.4364C8.26659 11.9545 7.85643 12.4726 7.44493 12.9907C7.35049 13.1095 7.25604 13.2282 7.16294 13.347C7.10627 13.4185 7.0658 13.4859 7.0658 13.5804C7.0658 13.6613 7.10223 13.7585 7.16294 13.8138C7.28167 13.9231 7.51507 13.9581 7.62977 13.8138V13.8138Z"
            fill="currentColor"
          />

          <path
            d="M12.2845 9.46668H13.4786H13.6486C13.5379 9.35605 13.4286 9.24676 13.318 9.13614V10.3302V10.5002C13.318 10.6729 13.4705 10.8388 13.6486 10.8307C13.828 10.8226 13.9791 10.685 13.9791 10.5002V9.30614V9.13614C13.9791 8.95804 13.828 8.80559 13.6486 8.80559H12.4545H12.2845C12.1118 8.80559 11.9458 8.95805 11.954 9.13614C11.9621 9.31558 12.0997 9.46668 12.2845 9.46668Z"
            fill="currentColor"
          />

          <path
            d="M12.9038 5.54442V5.54847C12.9038 6.65483 12.0079 7.55206 10.9015 7.55206C9.79516 7.55206 8.90198 6.65483 8.90198 5.54847C8.90198 4.4421 9.80056 3.54488 10.9069 3.54488V5.54442L12.9038 5.54442Z"
            fill="currentColor"
          />

          <path
            d="M13.3787 5.04508H11.3926V3.07521H11.398C11.5694 3.07521 11.7353 3.09275 11.8932 3.13323C11.9094 3.13728 11.9242 3.14267 11.9404 3.14267C12.7715 3.38553 13.3787 4.1411 13.3787 5.04506L13.3787 5.04508Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'financial_ratios':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.67798 2V5.66104H12.339C12.339 4.69004 11.9533 3.75888 11.2668 3.07228C10.5801 2.38575 9.64898 2.00002 8.678 2.00002L8.67798 2ZM9.49154 3.01695C9.97705 3.01695 10.4427 3.20981 10.7859 3.55312C11.1292 3.89635 11.3221 4.36196 11.3221 4.84747H9.49154V3.01695Z"
            fill="currentColor"
          />

          <path
            d="M7.86444 6.47451V2.81348C6.89344 2.81348 5.96228 3.1992 5.27568 3.88573C4.58915 4.57235 4.20343 5.50351 4.20343 6.47449C4.20343 7.44547 4.58915 8.37665 5.27568 9.06325C5.96231 9.74978 6.89347 10.1355 7.86444 10.1355C8.83542 10.1355 9.7666 9.74978 10.4532 9.06325C11.1397 8.37662 11.5255 7.44547 11.5255 6.47449L7.86444 6.47451Z"
            fill="currentColor"
          />

          <path
            d="M4 10.7457H4.81356V13.3898H4V10.7457Z"
            fill="currentColor"
          />

          <path
            d="M7.43465 12.7805C7.5209 12.8397 7.62696 12.8626 7.73002 12.8442C7.83298 12.8259 7.92469 12.7678 7.98517 12.6824C8.05436 12.5872 8.08187 12.4679 8.06126 12.352C8.04283 12.2388 7.97909 12.138 7.88465 12.0728L6.23737 10.9492H5.01703L5.02157 12.9831H5.63402L7.11034 13.9095C7.21948 13.9724 7.34387 14.0036 7.46981 13.9997C7.59566 13.9959 7.71797 13.957 7.82302 13.8877L11.3692 11.5606C11.4924 11.4857 11.5516 11.339 11.5151 11.1996C11.4786 11.0603 11.355 10.9615 11.2111 10.9566L7.18647 11.3453L8.00013 11.9051L8.00003 11.9051C8.13977 12.0013 8.23429 12.1502 8.26191 12.3176C8.29187 12.4876 8.25147 12.6624 8.14986 12.802C8.03645 12.9601 7.85396 13.0539 7.65945 13.0544C7.53796 13.0543 7.41938 13.0173 7.31949 12.9481L6.49568 12.3812L6.6109 12.2136L7.43465 12.7805Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'general':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.8462 14C12.5402 14 12.2467 13.8784 12.0302 13.6621C11.8139 13.4457 11.6923 13.1521 11.6923 12.8462V12.3846C11.6923 12.2572 11.7957 12.1539 11.9231 12.1539H12.6154V5.46154C12.6154 5.33411 12.7187 5.23077 12.8462 5.23077H13.7692C13.8304 5.23077 13.8892 5.25509 13.9324 5.29836C13.9757 5.34163 14 5.40035 14 5.46154V12.8462C14 13.1521 13.8784 13.4456 13.6621 13.6621C13.4457 13.8785 13.1522 14 12.8462 14ZM12.1539 12.6154V12.8462C12.1539 13.0935 12.2858 13.322 12.5 13.4457C12.7142 13.5694 12.9781 13.5694 13.1923 13.4457C13.4065 13.322 13.5385 13.0935 13.5385 12.8462V5.69231H13.0769V12.3846C13.0769 12.4458 13.0526 12.5045 13.0094 12.5478C12.9661 12.5911 12.9074 12.6154 12.8462 12.6154H12.1539Z"
            fill="currentColor"
          />

          <path
            d="M12.8461 12.6154H11.923C11.7956 12.6154 11.6923 12.5121 11.6923 12.3846V6.38461H9.24838L8.39453 7.24073C8.35106 7.284 8.29202 7.308 8.23073 7.30769H3.1538C3.02637 7.30769 2.92303 7.20436 2.92303 7.07692V2.23077C2.92303 2.10333 3.02637 2 3.1538 2H12.8461C12.9073 2 12.966 2.02431 13.0093 2.06758C13.0526 2.11085 13.0769 2.16957 13.0769 2.23077V12.3846C13.0769 12.4458 13.0526 12.5045 13.0093 12.5478C12.966 12.5911 12.9073 12.6154 12.8461 12.6154L12.8461 12.6154ZM12.1538 12.1538H12.6153V2.46154H3.38457V6.84615H8.13604L8.98989 5.99004C9.03336 5.94677 9.0924 5.92276 9.15369 5.92307H11.9229C11.9841 5.92307 12.0428 5.94738 12.0861 5.99065C12.1294 6.03392 12.1537 6.09265 12.1537 6.15384L12.1538 12.1538Z"
            fill="currentColor"
          />

          <path
            d="M12.8462 14H3.15385C2.84786 14 2.55437 13.8784 2.3379 13.6621C2.12155 13.4456 2 13.1521 2 12.8461V7.07692C2 6.94948 2.10333 6.84615 2.23077 6.84615H8.13609L8.98993 5.99003C9.03341 5.94677 9.09244 5.92276 9.15374 5.92307H11.923C11.9842 5.92307 12.0429 5.94738 12.0862 5.99065C12.1294 6.03392 12.1537 6.09264 12.1537 6.15384V12.8461C12.1537 13.0297 12.2267 13.2059 12.3565 13.3357C12.4863 13.4655 12.6625 13.5384 12.846 13.5384C12.9735 13.5384 13.0768 13.6418 13.0768 13.7692C13.0768 13.8966 12.9735 14 12.846 14L12.8462 14ZM2.46154 7.30769V12.8461C2.46154 13.0297 2.53448 13.2059 2.66429 13.3357C2.79409 13.4655 2.97027 13.5384 3.15383 13.5384H11.9231C11.7733 13.3387 11.6923 13.0958 11.6923 12.8461V6.3846H9.24841L8.39456 7.24071C8.35109 7.28398 8.29206 7.30798 8.23076 7.30768L2.46154 7.30769Z"
            fill="currentColor"
          />

          <path
            d="M8.46159 12.8461H5.69236C5.50877 12.8461 5.33259 12.7732 5.20281 12.6434C5.07302 12.5136 5.00006 12.3374 5.00006 12.1539V10.3077C5.00006 10.1241 5.073 9.94793 5.20281 9.81815C5.33262 9.68836 5.5088 9.6154 5.69236 9.6154H8.46159C8.64517 9.6154 8.82135 9.68834 8.95113 9.81815C9.08092 9.94796 9.15388 10.1241 9.15388 10.3077V12.1539C9.15388 12.3374 9.08094 12.5136 8.95113 12.6434C8.82133 12.7732 8.64515 12.8461 8.46159 12.8461ZM5.69236 10.0769C5.56492 10.0769 5.46159 10.1802 5.46159 10.3077V12.1538C5.46159 12.215 5.4859 12.2738 5.52917 12.317C5.57244 12.3603 5.63116 12.3846 5.69236 12.3846H8.46159C8.52278 12.3846 8.5815 12.3603 8.62477 12.317C8.66804 12.2738 8.69236 12.215 8.69236 12.1538V10.3077C8.69236 10.2465 8.66804 10.1878 8.62477 10.1445C8.5815 10.1012 8.52278 10.0769 8.46159 10.0769H5.69236Z"
            fill="currentColor"
          />

          <path
            d="M8.23078 10.0769H5.92309C5.79565 10.0769 5.69232 9.97358 5.69232 9.84614V9.15384C5.69232 8.65912 5.95627 8.20201 6.38463 7.95476C6.81299 7.7074 7.34088 7.7074 7.76924 7.95476C8.19761 8.20201 8.46155 8.65912 8.46155 9.15384V9.84614C8.46155 9.90734 8.43724 9.96606 8.39397 10.0093C8.3507 10.0526 8.29198 10.0769 8.23078 10.0769ZM6.15386 9.61537H8.00001V9.15384C8.00001 8.82406 7.82405 8.51931 7.53848 8.3544C7.2529 8.18956 6.90097 8.18956 6.6154 8.3544C6.32983 8.51934 6.15386 8.82409 6.15386 9.15384V9.61537Z"
            fill="currentColor"
          />

          <path
            d="M6.84615 11.9231C6.78486 11.9234 6.72582 11.8994 6.68235 11.8561L6.22081 11.3946C6.13025 11.3041 6.13025 11.1574 6.22081 11.067C6.31126 10.9764 6.45797 10.9764 6.54842 11.067L6.84616 11.367L7.60543 10.6054C7.69588 10.5149 7.84258 10.5149 7.93304 10.6054C8.0236 10.6959 8.0236 10.8426 7.93304 10.933L7.00996 11.8561C6.96649 11.8994 6.90746 11.9234 6.84616 11.9231H6.84615Z"
            fill="currentColor"
          />

          <path
            d="M6.84614 6.15385H4.53845C4.41101 6.15385 4.30768 6.05051 4.30768 5.92308C4.30768 5.42836 4.57163 4.97125 4.99999 4.724C5.42835 4.47664 5.95624 4.47664 6.3846 4.724C6.81296 4.97125 7.07691 5.42836 7.07691 5.92308C7.07691 5.98427 7.0526 6.04299 7.00933 6.08626C6.96606 6.12953 6.90733 6.15385 6.84614 6.15385ZM4.7992 5.69231H6.58541C6.51608 5.42701 6.33239 5.20635 6.0841 5.08993C5.83592 4.97352 5.54869 4.97352 5.30051 5.08993C5.05223 5.20635 4.86854 5.42701 4.7992 5.69231Z"
            fill="currentColor"
          />

          <path
            d="M5.69236 4.99999C5.44759 4.99999 5.21279 4.90274 5.03962 4.72966C4.86654 4.55648 4.76929 4.32169 4.76929 4.07692C4.76929 3.83214 4.86654 3.59734 5.03962 3.42417C5.2128 3.25109 5.44759 3.15384 5.69236 3.15384C5.93714 3.15384 6.17194 3.25109 6.34511 3.42417C6.51819 3.59735 6.61544 3.83214 6.61544 4.07692C6.61544 4.32169 6.51819 4.55649 6.34511 4.72966C6.17193 4.90274 5.93714 4.99999 5.69236 4.99999ZM5.69236 3.61538C5.56997 3.61538 5.45253 3.66401 5.36599 3.75054C5.27945 3.83708 5.23083 3.95453 5.23083 4.07692C5.23083 4.19931 5.27945 4.31675 5.36599 4.40329C5.45253 4.48983 5.56997 4.53845 5.69236 4.53845C5.81475 4.53845 5.9322 4.48983 6.01874 4.40329C6.10527 4.31675 6.1539 4.19931 6.1539 4.07692C6.1539 3.95453 6.10527 3.83708 6.01874 3.75054C5.9322 3.66401 5.81475 3.61538 5.69236 3.61538Z"
            fill="currentColor"
          />

          <path
            d="M11.4616 4.07691H8.92309C8.79565 4.07691 8.69232 3.97358 8.69232 3.84614C8.69232 3.7187 8.79565 3.61537 8.92309 3.61537H11.4616C11.589 3.61537 11.6923 3.7187 11.6923 3.84614C11.6923 3.97358 11.589 4.07691 11.4616 4.07691Z"
            fill="currentColor"
          />

          <path
            d="M11.4616 5.23076H8.92309C8.79565 5.23076 8.69232 5.12743 8.69232 5C8.69232 4.87256 8.79565 4.76923 8.92309 4.76923H11.4616C11.589 4.76923 11.6923 4.87256 11.6923 5C11.6923 5.12743 11.589 5.23076 11.4616 5.23076Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'other_data_from_annual_account':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_503_375)">
            <path
              d="M13.5714 2H2.42857C2.192 2 2 2.192 2 2.42857V13.5714C2 13.808 2.192 14 2.42857 14H13.5714C13.808 14 14 13.808 14 13.5714V2.42857C14 2.192 13.808 2 13.5714 2ZM13.1429 13.1429H2.85714V6.28571H6.28571C6.52229 6.28571 6.71429 6.09372 6.71429 5.85714C6.71429 5.62057 6.52229 5.42857 6.28571 5.42857H2.85714V2.85714H13.1429V5.42857H9.71429C9.47771 5.42857 9.28571 5.62057 9.28571 5.85714C9.28571 6.09372 9.47771 6.28571 9.71429 6.28571H13.1429V13.1429Z"
              fill="currentColor"
            />

            <path
              d="M8.00001 5.42862C7.76391 5.42862 7.57144 5.23614 7.57144 5.00005C7.57144 4.76395 7.76391 4.57148 8.00001 4.57148C8.2361 4.57148 8.42858 4.76395 8.42858 5.00005C8.42858 5.23662 8.62058 5.42862 8.85715 5.42862C9.09373 5.42862 9.28572 5.23662 9.28572 5.00005C9.28572 4.44205 8.92611 3.97062 8.42858 3.79317V3.71434C8.42858 3.47776 8.23658 3.28577 8.00001 3.28577C7.76343 3.28577 7.57144 3.47776 7.57144 3.71434V3.79317C7.0739 3.97062 6.71429 4.44205 6.71429 5.00005C6.71429 5.7089 7.29115 6.28576 8.00001 6.28576C8.2361 6.28576 8.42858 6.47824 8.42858 6.71433C8.42858 6.95043 8.2361 7.1429 8.00001 7.1429C7.76391 7.1429 7.57144 6.95043 7.57144 6.71433C7.57144 6.47776 7.37944 6.28576 7.14287 6.28576C6.90629 6.28576 6.71429 6.47776 6.71429 6.71433C6.71429 7.27233 7.0739 7.74376 7.57144 7.92122V8.00004C7.57144 8.23662 7.76343 8.42861 8.00001 8.42861C8.23658 8.42861 8.42858 8.23662 8.42858 8.00004V7.92122C8.92611 7.74376 9.28572 7.27233 9.28572 6.71433C9.28572 6.00548 8.70887 5.42862 8.00001 5.42862Z"
              fill="currentColor"
            />

            <path
              d="M5.42856 6.71423H3.71428C3.4777 6.71423 3.28571 6.90623 3.28571 7.1428V8.85709C3.28571 9.09367 3.4777 9.28566 3.71428 9.28566H5.42856C5.66514 9.28566 5.85713 9.09367 5.85713 8.85709V7.1428C5.85713 6.90623 5.66514 6.71423 5.42856 6.71423ZM4.99999 8.42852H4.14285V7.57138H4.99999V8.42852Z"
              fill="currentColor"
            />

            <path
              d="M5.42856 10.1428H3.71428C3.4777 10.1428 3.28571 10.3348 3.28571 10.5714V12.2857C3.28571 12.5223 3.4777 12.7143 3.71428 12.7143H5.42856C5.66514 12.7143 5.85713 12.5223 5.85713 12.2857V10.5714C5.85713 10.3348 5.66514 10.1428 5.42856 10.1428ZM4.99999 11.8571H4.14285V11H4.99999V11.8571Z"
              fill="currentColor"
            />

            <path
              d="M10.5715 9.28566H12.2857C12.5223 9.28566 12.7143 9.09367 12.7143 8.85709V7.1428C12.7143 6.90623 12.5223 6.71423 12.2857 6.71423H10.5715C10.3349 6.71423 10.1429 6.90623 10.1429 7.1428V8.85709C10.1429 9.09367 10.3349 9.28566 10.5715 9.28566ZM11 7.57138H11.8572V8.42852H11V7.57138Z"
              fill="currentColor"
            />

            <path
              d="M10.5715 12.7143H12.2857C12.5223 12.7143 12.7143 12.5223 12.7143 12.2857V10.5714C12.7143 10.3348 12.5223 10.1428 12.2857 10.1428H10.5715C10.3349 10.1428 10.1429 10.3348 10.1429 10.5714V12.2857C10.1429 12.5223 10.3349 12.7143 10.5715 12.7143ZM11 11H11.8572V11.8571H11V11Z"
              fill="currentColor"
            />

            <path
              d="M8.85715 10.1428H7.14287C6.90629 10.1428 6.71429 10.3348 6.71429 10.5714V12.2857C6.71429 12.5223 6.90629 12.7143 7.14287 12.7143H8.85715C9.09373 12.7143 9.28572 12.5223 9.28572 12.2857V10.5714C9.28572 10.3348 9.09373 10.1428 8.85715 10.1428ZM8.42858 11.8571H7.57144V11H8.42858V11.8571Z"
              fill="currentColor"
            />
          </g>

          <defs>
            <clipPath id="clip0_503_375">
              <rect
                fill="white"
                height="26"
                width="26"
              />
            </clipPath>
          </defs>
        </svg>
      )
    case 'payment_behaviour':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.37091 4.84524C9.32252 5.09685 9.32252 5.36782 9.39026 5.63878C9.41929 5.76459 9.47736 5.89039 9.56445 6.01619C9.64187 6.13231 9.74832 6.20973 9.86444 6.24844C9.88379 6.25812 9.90315 6.25812 9.93218 6.2678C10.0773 6.30651 10.2419 6.27747 10.3773 6.19038C10.5128 6.10328 10.6096 6.01619 10.687 5.90972C10.8515 5.68716 10.958 5.43552 11.016 5.18394L11.0257 5.1549C11.0354 5.12587 11.0354 5.09684 11.0451 5.06781C11.0741 4.77749 10.9677 4.53556 10.716 4.37104C10.6096 4.3033 10.4935 4.25491 10.358 4.22588C10.2225 4.19685 10.0967 4.19685 9.97088 4.2162C9.68056 4.26459 9.48701 4.43877 9.39993 4.72911C9.39025 4.75814 9.39025 4.78718 9.38057 4.81621L9.37091 4.84524Z"
            fill="currentColor"
          />

          <path
            d="M10.0966 12.0547L9.74824 11.8321L8.67407 11.116L8.65471 11.3095C8.616 11.7644 8.55794 12.3063 8.51923 12.5579L6.32249 12.6934C6.12894 12.7031 5.97411 12.8676 5.96442 13.0612C5.95473 13.2547 6.09022 13.4192 6.27409 13.4579L8.58692 13.9128H8.66434C8.74176 13.9128 8.81917 13.9128 8.89659 13.9224H8.92562C8.97401 13.9224 9.03208 13.9128 9.08046 13.9031C9.27401 13.8547 9.42885 13.7192 9.51595 13.516L9.63208 13.245C9.69982 13.0805 9.78692 12.8869 9.86434 12.6934C9.89337 12.616 9.93208 12.5289 9.96111 12.4515V12.4418C9.98046 12.4031 9.99014 12.3547 10.0095 12.3257L10.0482 12.2192C10.0482 12.2095 10.0482 12.2095 10.0579 12.1998L10.0966 12.0547Z"
            fill="currentColor"
          />

          <path
            d="M12.4676 13.4387L11.6353 11.4161C11.6063 11.329 11.5482 11.2516 11.4805 11.1839L11.4224 11.1355C11.1418 10.8742 10.474 10.2645 10.1837 9.9839C10.174 9.97422 10.1547 9.92584 10.1644 9.88713C10.1837 9.28713 10.2902 8.70649 10.3386 8.11619C10.3773 7.65167 10.3579 7.10005 9.93212 6.80007C9.69986 6.64523 9.40954 6.5775 9.12891 6.60652C8.84828 6.63554 8.58698 6.77104 8.3257 6.8678C8.13215 6.93554 7.9483 7.00328 7.75475 7.0807C7.60959 7.13876 7.46443 7.18715 7.31926 7.24521C7.27087 7.26457 7.19345 7.31296 7.13539 7.31296L5.34507 7.3807C5.18056 7.39037 5.02571 7.5065 5.00638 7.67102C4.97734 7.87424 5.13218 8.04842 5.33541 8.05811L7.21281 8.12585H7.98699C8.05474 8.12585 8.13215 8.11617 8.1999 8.1065C8.44184 8.05811 8.65472 7.92263 8.79989 7.74842C8.8386 7.70004 8.90634 7.69036 8.95473 7.72907C9.00311 7.76778 9.01279 7.83552 8.97408 7.88391L8.94505 7.91294C8.76118 8.12584 8.50956 8.26132 8.23859 8.31939C8.24827 8.36777 8.25795 8.41616 8.26763 8.45487V8.47422V8.4839C8.38375 8.94841 8.25795 9.41293 8.29666 9.88713C8.32569 10.3032 8.54827 10.6903 8.88699 10.9226C9.45794 11.3097 10.2999 11.8613 10.416 11.929C10.4257 11.9387 10.4354 11.9387 10.445 11.9484C10.4934 12.0161 10.716 12.3548 10.716 12.3548L11.7224 13.8355C11.7999 13.9419 11.916 14 12.0418 14C12.0999 14 12.1676 13.9806 12.2257 13.9516L12.2741 13.9226C12.4676 13.8258 12.545 13.6129 12.4676 13.4387H12.4676Z"
            fill="currentColor"
          />

          <path
            d="M6.39998 2C5.07417 2 4 3.07417 4 4.39998C4 5.72578 5.07417 6.79996 6.39998 6.79996C7.72578 6.79996 8.79996 5.72578 8.79996 4.39998C8.79996 3.07417 7.72578 2 6.39998 2ZM6.39998 6.23856C5.39354 6.23856 4.57095 5.41598 4.57095 4.39987C4.57095 3.39342 5.39354 2.57084 6.39998 2.57084C7.40642 2.57084 8.229 3.39342 8.229 4.39987C8.229 5.416 7.40642 6.23856 6.39998 6.23856Z"
            fill="currentColor"
          />

          <path
            d="M6.8063 4.38073C6.69985 4.30331 6.58373 4.25492 6.4676 4.20653C6.36115 4.15815 6.28373 4.11944 6.21599 4.07105C6.10954 4.00331 6.09987 3.90654 6.11922 3.82911C6.13857 3.73233 6.19664 3.66459 6.29341 3.62588C6.39986 3.58717 6.50631 3.59685 6.60309 3.6162C6.69018 3.62588 6.7676 3.66459 6.8547 3.7033L6.88373 3.72266L6.91276 3.64524C6.93212 3.59685 6.95147 3.53879 6.97082 3.4904C6.9805 3.47104 6.96115 3.43234 6.94179 3.42266L6.90308 3.4033L6.75792 3.34524C6.69986 3.33556 6.65147 3.32588 6.59341 3.31621C6.57405 3.31621 6.56438 3.30653 6.54502 3.30653V2.98717H6.28375V3.32586L6.26439 3.33554C6.15794 3.36457 6.06117 3.40328 5.98374 3.47102C5.85793 3.5678 5.78051 3.7323 5.77084 3.89683C5.77084 4.05166 5.83858 4.19681 5.95471 4.29361C6.05148 4.37103 6.15793 4.42909 6.31278 4.49683C6.41923 4.53554 6.50632 4.57425 6.58374 4.64199C6.68052 4.71941 6.71923 4.82586 6.70955 4.93231C6.69019 5.03876 6.62245 5.11618 6.52568 5.16457C6.46762 5.18392 6.40955 5.1936 6.34181 5.1936C6.19665 5.20328 6.05149 5.16457 5.89665 5.08715L5.82891 5.03876L5.79988 5.12586C5.78052 5.17424 5.77085 5.21295 5.75149 5.26134C5.74182 5.30005 5.75149 5.3194 5.78052 5.33876C5.86762 5.38715 5.95472 5.42585 6.05149 5.44521C6.09988 5.45489 6.14826 5.46456 6.20633 5.46456C6.22568 5.46456 6.23536 5.46456 6.25471 5.47424V5.80327H6.53537V5.45489C6.54504 5.45489 6.5644 5.44521 6.57408 5.44521C6.61279 5.43553 6.6515 5.42585 6.69988 5.4065C6.91278 5.3194 7.03858 5.15489 7.06762 4.94199C7.08698 4.70973 6.99988 4.52587 6.80634 4.3807L6.8063 4.38073Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'popular':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00016 1.5L9.86686 6.63314H15L10.8 9.43311L12.6667 14.5663L8 11.2997L3.33325 14.5663L5.19995 9.43311L1 6.63314H6.13314L8.00016 1.5Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'quarterly_data_from_etcb':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.704 6.74962C10.2559 6.74962 9.84638 6.83927 9.4496 6.97998V4.21518C9.4496 3.08875 7.568 2.5 5.7248 2.5C3.88158 2.5 2 3.08885 2 4.21518V10.628C2 11.7544 3.8816 12.3432 5.7248 12.3432C6.45445 12.3432 7.184 12.2535 7.79838 12.0743C8.41275 13.0215 9.48802 13.6615 10.704 13.6615C12.6112 13.6615 14.16 12.1127 14.16 10.2055C14.16 8.29838 12.6111 6.74953 10.704 6.74953V6.74962ZM5.72478 11.6008C3.93282 11.6008 2.74238 11.012 2.74238 10.628V10.0904C3.45915 10.5128 4.59835 10.7432 5.72478 10.7432C6.2496 10.7432 6.77442 10.6921 7.26075 10.6024C7.29915 10.884 7.36317 11.1528 7.45272 11.396C6.99192 11.524 6.40316 11.6008 5.72476 11.6008L5.72478 11.6008ZM7.26075 9.84725C6.82558 9.94966 6.30075 10.0008 5.72478 10.0008C3.93282 10.0008 2.74238 9.41197 2.74238 9.02804V8.49044C3.45915 8.91284 4.59835 9.14322 5.72478 9.14322C6.32638 9.14322 6.94075 9.0792 7.47835 8.95125C7.37594 9.23276 7.29916 9.52723 7.26077 9.84723L7.26075 9.84725ZM8.71995 7.37685C8.47673 7.55604 8.24638 7.76087 8.05433 7.99122C7.52951 8.22158 6.72318 8.40087 5.73753 8.40087C3.94558 8.40087 2.75513 7.81202 2.75513 7.42809V6.89049C3.47191 7.31289 4.61111 7.54327 5.73753 7.54327C6.87673 7.54327 8.00315 7.32568 8.71993 6.89049L8.71995 7.37685ZM8.71995 5.81525C8.71995 6.19927 7.5296 6.78802 5.73755 6.78802C3.9456 6.78802 2.75515 6.19918 2.75515 5.81525V5.27765C3.47193 5.70005 4.61113 5.93042 5.73755 5.93042C6.87675 5.93042 8.00318 5.71283 8.71995 5.27765V5.81525ZM5.72475 5.18809C3.9328 5.18809 2.74235 4.59925 2.74235 4.21531C2.74235 3.83129 3.93271 3.24254 5.72475 3.24254C7.51671 3.24254 8.70715 3.83138 8.70715 4.21531C8.70715 4.59925 7.52955 5.18809 5.72475 5.18809ZM9.61595 8.54169C9.93595 8.54169 10.1919 8.79767 10.1919 9.11767C10.1919 9.43767 9.93595 9.69365 9.61595 9.69365C9.29595 9.69365 9.03998 9.43767 9.03998 9.11767C9.03998 8.79767 9.29595 8.54169 9.61595 8.54169ZM9.76962 11.6137C9.7056 11.6777 9.61604 11.7161 9.52639 11.7161C9.43674 11.7161 9.35997 11.6777 9.28317 11.6137C9.15513 11.4857 9.15513 11.2681 9.28317 11.1401L11.6384 8.78491C11.7664 8.65688 11.984 8.65688 12.1119 8.78491C12.24 8.91295 12.24 9.13054 12.1119 9.25849L9.76962 11.6137ZM11.7919 11.8698C11.4719 11.8698 11.216 11.6138 11.216 11.2938C11.216 10.9738 11.4719 10.7178 11.7919 10.7178C12.1119 10.7178 12.3679 10.9738 12.3679 11.2938C12.368 11.6137 12.1119 11.8698 11.7919 11.8698Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'related_parties':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.99998 11.6C5.11061 11.6 5.19998 11.5106 5.19998 11.4V8.99999H5.79998C5.91061 8.99999 5.99998 8.91062 5.99998 8.79999V7.39999C5.99998 6.84857 5.55141 6.39999 4.99998 6.39999H4.89195C5.08275 6.1874 5.19999 5.90758 5.19999 5.59999C5.19999 4.93821 4.66177 4.39999 3.99999 4.39999C3.33821 4.39999 2.79999 4.93821 2.79999 5.59999C2.79999 5.90758 2.91722 6.1874 3.10804 6.39999H3C2.44857 6.39999 2 6.84857 2 7.39999V8.79999C2 8.91062 2.08938 8.99999 2.2 8.99999H2.8V11.4C2.8 11.5106 2.88938 11.6 3 11.6H4.99998ZM3.19998 5.59999C3.19998 5.15883 3.55882 4.79999 3.99998 4.79999C4.44115 4.79999 4.79998 5.15883 4.79998 5.59999C4.79998 6.04116 4.44115 6.39999 3.99998 6.39999C3.55882 6.39999 3.19998 6.04116 3.19998 5.59999ZM3.79998 8.99999V11.2H3.19998V7.39999H2.79998V8.59999H2.39998V7.39999C2.39998 7.06918 2.66917 6.79999 2.99998 6.79999H4.99998C5.33079 6.79999 5.59998 7.06918 5.59998 7.39999V8.59999H5.19998V7.39999H4.79998V11.2H4.19998V8.99999H3.79998Z"
            fill="currentColor"
          />

          <path
            d="M13 6.39999H12.8919C13.0827 6.1874 13.2 5.90758 13.2 5.59999C13.2 4.93821 12.6618 4.39999 12 4.39999C11.3382 4.39999 10.8 4.93821 10.8 5.59999C10.8 5.90758 10.9172 6.1874 11.108 6.39999H11C10.4486 6.39999 10 6.84857 10 7.39999V8.79999C10 8.91062 10.0894 8.99999 10.2 8.99999H10.8V11.4C10.8 11.5106 10.8894 11.6 11 11.6H13C13.1106 11.6 13.2 11.5106 13.2 11.4V8.99999H13.8C13.9106 8.99999 14 8.91062 14 8.79999V7.39999C14 6.84857 13.5514 6.39999 13 6.39999H13ZM11.2 5.59999C11.2 5.15883 11.5588 4.79999 12 4.79999C12.4411 4.79999 12.8 5.15883 12.8 5.59999C12.8 6.04116 12.4411 6.39999 12 6.39999C11.5588 6.39999 11.2 6.04116 11.2 5.59999ZM13.6 8.59999H13.2V7.39999H12.8V11.2H12.2V8.99999H11.8V11.2H11.2V7.39999H10.8V8.59999H10.4V7.39999C10.4 7.06918 10.6692 6.79999 11 6.79999H13C13.3308 6.79999 13.6 7.06918 13.6 7.39999V8.59999Z"
            fill="currentColor"
          />

          <path
            d="M11.8 3V3.31723L11.3415 2.85867L11.0587 3.14144L11.8587 3.94144C11.8976 3.98037 11.9489 4.00001 12 4.00001C12.0512 4.00001 12.1024 3.98037 12.1415 3.94144L12.9415 3.14144L12.6587 2.85867L12.2 3.31723V3C12.2 2.44857 11.7515 2 11.2 2H6.60004V2.4H11.2C11.5308 2.4 11.8 2.66919 11.8 3H11.8Z"
            fill="currentColor"
          />

          <path
            d="M4.19999 3C4.19999 2.66919 4.46918 2.4 4.79999 2.4H6.19999V2H4.79999C4.24856 2 3.79999 2.44857 3.79999 3V4H4.19999V3Z"
            fill="currentColor"
          />

          <path
            d="M4.19997 13V12.6828L4.65853 13.1413L4.9413 12.8586L4.1413 12.0586C4.06308 11.9803 3.93666 11.9803 3.85853 12.0586L3.05853 12.8586L3.3413 13.1413L3.79995 12.6828V13C3.79995 13.5514 4.24852 14 4.79995 14H8.59995V13.6H4.79995C4.46914 13.6 4.19995 13.3308 4.19995 13H4.19997Z"
            fill="currentColor"
          />

          <path
            d="M9 13.6H9.4V14H9V13.6Z"
            fill="currentColor"
          />

          <path
            d="M11.8 13C11.8 13.3308 11.5308 13.6 11.2 13.6H9.79999V14H11.2C11.7514 14 12.2 13.5514 12.2 13V12H11.8V13Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'page_first':
      return (
        <svg
          height="9"
          viewBox="0 0 7 9"
          width="7"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 8.5L7 0.5L1.55556 4.5L7 8.5ZM0 0.5L0 8.5H1.55556L1.55556 0.5H0Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'page_previous':
      return (
        <svg
          height="10"
          viewBox="0 0 6 10"
          width="6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.80859 0.5L0 5L4.80859 9.5L6 8.38505L2.38281 5L6 1.61495L4.80859 0.5Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'page_next':
      return (
        <svg
          height="10"
          viewBox="0 0 6 10"
          width="6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.19141 9.5L6 5L1.19141 0.5L0 1.61495L3.61719 5L0 8.38505L1.19141 9.5Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'page_last':
      return (
        <svg
          height="9"
          viewBox="0 0 7 9"
          width="7"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0.5V8.5L5.44444 4.5L0 0.5ZM7 8.5V0.5H5.44444V8.5H7Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'checked':
      return (
        <svg
          viewBox="0 0 12 12"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              d="M9.854 3.146a.5.5 0 0 1 0 .708l-4.5 4.5a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L5 7.293l4.146-4.147a.5.5 0 0 1 .708 0z"
              fill="currentColor"
            />
          </g>
        </svg>
      )
    case 'close':
      return (
        <svg
          height="18"
          viewBox="0 0 16 16"
          width="18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            d="M7.11598 8L2.55798 12.558L3.44198 13.442L7.99998 8.884L12.558 13.442L13.442 12.558L8.88398 8L13.442 3.442L12.558 2.558L7.99998 7.116L3.44198 2.558L2.55798 3.442L7.11598 8Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </svg>
      )
    case 'add':
      return (
        <svg
          height="18"
          viewBox="0 0 16 16"
          width="18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 7.21429H8.78571V2.5H7.21429V7.21429H2.5V8.78571H7.21429V13.5H8.78571V8.78571H13.5V7.21429Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'remove':
      return (
        <svg
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 15h16v2H8z"
            fill="currentColor"
          />
        </svg>
      )
    case 'burger':
      return (
        <svg
          height="18"
          viewBox="0 0 16 16"
          width="18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.75 12.25H13.25M2.75 8.25H13.25M2.75 4.25H13.25"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </svg>
      )
    case 'chevron_up':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 6.19141L8 11L12.5 6.19141L11.3851 5L8 8.61719L4.61495 5L3.5 6.19141Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'chevron_down':
      return (
        <svg
          height="26"
          viewBox="0 0 16 16"
          width="26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 9.80859L8 5L3.5 9.80859L4.61495 11L8 7.38281L11.3851 11L12.5 9.80859Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'chevron_right':
      return (
        <svg
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M184 112l144 144l-144 144"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="48"
          />
        </svg>
      )
    default:
      return (<div />)
  }
}
